import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LS } from 'src/app/helpers/localStorage.enum';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { marker as _t_marker } from '@biesbjerg/ngx-translate-extract-marker'

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.sass']
})
export class NotificationsComponent implements OnInit {
  notifications: Array<any>
  auditTrails: any[]
  isForYouSelected: boolean = true
  querySub: Subscription
  canAccessGeneralNotification = false

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const currentUser = JSON.parse(localStorage.getItem(LS.currentUser))
    this.canAccessGeneralNotification = currentUser.permissions['read:any.audittrail']
    this.querySub = this.route.queryParams.subscribe((res) => {
      this.isForYouSelected = !res.general
    })
    this.getNotifications()
    this.getGeneralNotifications()
  }

  ngOnDestroy() {
    this.querySub.unsubscribe()
  }

  getNotifications() {
    this.notificationService.findAll().subscribe(res => {
      this.notifications = res.map((noty) => {
        noty.url = noty.sender?.avatar?.url_small
          || noty.sender?.avatar?.url
          || '/assets/images/avatar.svg'

        noty.text = _t_marker('{{assigner:name}} assigned you a new task for {{annotation:name}}')
        return noty
      })
      // this.notifications.push(...res)
    });
  }

  getAssigner(title: string) {
    const titles = title.split(' assigned you a new task for annotation ')
    return titles[0]
  }

  getAnnotation(title: string) {
    const titles = title.split(' assigned you a new task for annotation ')
    return titles[1]
  }

  getGeneralNotifications() {
    this.notificationService.findGeneralNotifications().subscribe(res => {
      this.auditTrails = res.map((noty) => {
        noty.url = noty.user?.avatar?.url_small
          || noty.user?.avatar?.url
          || '/assets/images/avatar.svg'
        return noty
      })
    });
  }

  getTitleAction(title: string) {
    const action = title.split(' ').slice(0, 2).join(' ')
    if (action === 'Update Project') return title.split(' ').slice(0, 3).join(' ')
    return `${action}`
  }

  getTitleItem(title: string) {
    const action = title.split(' ').slice(0, 2).join(' ')
    if (action === 'Update Project') return ''
    const item = title.split(' ').slice(2).join(' ')
    return item === '' ? '' : `${item} /`
  }

  onClickNotification(notification) {
    this.notificationService.update(notification.id).subscribe(res => {
      this.router.navigate([notification.route])
    })
  }

  onClickAuditTrail(auditTrail) {
    let view
    if (auditTrail.title.toLowerCase().includes('task')) view = 'tasks'
    if (auditTrail.title.toLowerCase().includes('annotation')) view = 'annotations'
    if (auditTrail.title.toLowerCase().includes('project')) view = 'summary'
    if (auditTrail.title.toLowerCase().includes('maplayer')) view = 'info'
    if (!view) return
    const path = `/projects/${auditTrail.location.id}/details/${view}`
    this.router.navigate([path])
  }

  async onClickReadAll() {
    for (let notification of this.notifications) {
      if (!notification.has_read) await this.notificationService.update(notification.id).toPromise()
    }
    this.notificationService.findAll().subscribe(res => {
      this.notifications = res
    });
  }

  onClickSettings() {
    this.router.navigate(['/notifications', 'settings'])
  }
}
